import React from 'react';
import packageJson from '../../../../web/package.json';

import styles from './InfoDevice.styles';

export const InfoDevice: React.FC = () => {
  const version = packageJson.version;

  return (
    <div style={styles.container}>
      <span style={styles.libelle}>v{version}</span>
    </div>
  );
};

export default InfoDevice;
